import React, { useState } from "react";
import CarePlanning from "../../assets/images/icons/reports/CarePlanning.svg";
import ClientReports from "../../assets/images/icons/reports/ClientReports.svg";
import EmarReports from "../../assets/images/icons/reports/EmarReports.svg";
import HistoricStaffReports from "../../assets/images/icons/reports/HistoricStaffReports.svg";
import Holidays from "../../assets/images/icons/reports/Holidays.svg";
import PayrollHistoricReports from "../../assets/images/icons/reports/PayrollHistoricReports.svg";
import PayrollReports from "../../assets/images/icons/reports/PayrollReports.svg";
import RosterReports from "../../assets/images/icons/reports/RosterReports.svg";
import StaffReports from "../../assets/images/icons/reports/StaffReports.svg";
import Supervision from "../../assets/images/icons/reports/Supervision.svg";
import ListOfAudits from "../../assets/images/icons/reports/ListOfAudits.svg";
import { useNavigate } from "react-router-dom";
import PermissionWrapper from "../../permission_advance/PermissionWrapper";
import ServiceUsersOptionsBlocks from "../../components/user-detail/ServiceUsersOptionsBlocks";
import Layout from "../../components/layouts/Layout";

function Reports() {
    const navigate = useNavigate();
    const handleRowClickReports = (url) => {
        navigate(url);
    };
    return (
        <>
            <Layout pageTitleText="Reports">
                <div className="scheduleBlocks careplanOptions reportsWrapper">
                    {/* Care Planning */}
                    <div className="row">
                        {/* Latest Care Reviews */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={CarePlanning}
                                    heading={"Latest Care Reviews"}
                                    linkedComponent={() => { handleRowClickReports("/reports/latest-care-reviews") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* Care Plan Access Log */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={CarePlanning}
                                    heading={"Care Plan Access Log"}
                                    linkedComponent={() => { handleRowClickReports("/reports/careplan-logs-reports") }}
                                />
                            </div>
                        </PermissionWrapper>
                    </div>

                    {/* Client Reports */}
                    <div className="row">
                        {/*Active Client Reports */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={ClientReports}
                                    heading={"Active Client Reports"}
                                    linkedComponent={() => { handleRowClickReports("/reports/client-reports") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/*Historic Client Reports */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={ClientReports}
                                    heading={"Historic Client Reports"}
                                    linkedComponent={() => { handleRowClickReports("/reports/historic-client-reports") }}
                                />
                            </div>
                        </PermissionWrapper>

                    </div>

                    {/* eMAR Reports */}
                    <div className="row">
                        {/* eMAR Administration - Full */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={EmarReports}
                                    heading={"eMAR Administration - Full"}
                                    linkedComponent={() => { handleRowClickReports("/reports/emar-full") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* eMAR Administration - Late */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={EmarReports}
                                    heading={"eMAR Administration - Late"}
                                    linkedComponent={() => { handleRowClickReports("/reports/emar-late") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* eMAR Administration - Missed */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={EmarReports}
                                    heading={"eMAR Administration - Missed"}
                                    linkedComponent={() => { handleRowClickReports("/reports/emar-missed") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* eMAR Control Drugs - Active */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={EmarReports}
                                    heading={"eMAR Control Drugs - Active"}
                                    linkedComponent={() => { handleRowClickReports("/reports/active-control") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* eMAR Control Drugs - All */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={EmarReports}
                                    heading={"eMAR Control Drugs - All"}
                                    linkedComponent={() => { handleRowClickReports("/reports/all-active-control") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* eMAR Medication Administration Corrections */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={EmarReports}
                                    heading={"eMAR Medication Administration Corrections"}
                                    linkedComponent={() => { handleRowClickReports("/reports/emar-reports") }}
                                />
                            </div>
                        </PermissionWrapper>
                    </div>

                    {/* Holiday */}
                    <div className="row">
                        {/* Holidays Requests */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={Holidays}
                                    heading={"Holidays Requests"}
                                    linkedComponent={() => { handleRowClickReports("/reports/holidays-requests") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* List Of Audits */}
                        {/* <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={ListOfAudits}
                                    heading={"List Of Audits"}
                                    linkedComponent={() => { handleRowClickReports("/reports/list-of-audits") }}
                                />
                            </div>
                        </PermissionWrapper> */}









                    </div>

                    {/* <div className="row">
                       
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={PayrollHistoricReports}
                                    heading={"Payroll Historic Reports"}
                                    linkedComponent={() => { handleRowClickReports("/reports/payroll-historic-reports") }}
                                />
                            </div>
                        </PermissionWrapper>

                        
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={PayrollReports}
                                    heading={"Payroll Reports"}
                                    linkedComponent={() => { handleRowClickReports("/reports/payroll-reports") }}
                                />
                            </div>
                        </PermissionWrapper>
                    </div> */}

                    <div className="row">
                        {/* Roster Reports */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={RosterReports}
                                    heading={"Roster: Active Template vs Contract"}
                                    linkedComponent={() => { handleRowClickReports("/reports/roster-reports") }}
                                />
                            </div>
                        </PermissionWrapper>
                        {/* Live Rota vs Contract Hours */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={RosterReports}
                                    heading={"Live Rota vs Contract Hours"}
                                    linkedComponent={() => { handleRowClickReports("") }}
                                />
                            </div>
                        </PermissionWrapper>
                    </div>


                    <div className="row">

                        {/* Historic Staff Reports */}
                        <PermissionWrapper title="Reports" action="view">

                            <div className="col-md-2 col-sm-6">

                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={HistoricStaffReports}
                                    heading={"Historic Staff Reports"}
                                    linkedComponent={() => { handleRowClickReports("/reports/historic-staff-reports") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* Active Staff - All Fields */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={StaffReports}
                                    heading={"Active Staff Reports"}
                                    linkedComponent={() => { handleRowClickReports("/reports/active-staff-reports") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* Active Staff Sickness by Month */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={StaffReports}
                                    heading={"Active Staff Sickness by Month"}
                                    linkedComponent={() => { handleRowClickReports("/reports/staff-sickness-reports") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* Staff Absence Summary Report */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={StaffReports}
                                    heading={"Staff Absence Summary Report"}
                                    linkedComponent={() => { handleRowClickReports("/reports/staff-absence-summary-reports") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* Users Report */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    reportDone={true}
                                    blockIcon={StaffReports}
                                    heading={"Users Report"}
                                    linkedComponent={() => { handleRowClickReports("/reports/users-logs-reports") }}
                                />
                            </div>
                        </PermissionWrapper>
                    </div>

                    <div className="row">
                        {/* All Supervision Actions */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={Supervision}
                                    heading={"All Supervision Actions"}
                                    linkedComponent={() => { handleRowClickReports("/reports/all-supervision-actions-reports") }}
                                />
                            </div>
                        </PermissionWrapper>
                        {/* Supervision Logs - Last 12 months */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={Supervision}
                                    heading={"Supervision Logs - Last 12 months"}
                                    linkedComponent={() => { handleRowClickReports("") }}
                                />
                            </div>
                        </PermissionWrapper>

                        {/* Supervisions Summary */}
                        <PermissionWrapper title="Reports" action="view">
                            <div className="col-md-2 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={Supervision}
                                    heading={"Supervisions Summary"}
                                    linkedComponent={() => { handleRowClickReports("") }}
                                />
                            </div>
                        </PermissionWrapper>
                    </div>

                </div>
            </Layout>
        </>
    )
}

export default Reports